import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormControlService } from '../../shared/services/form-control.service';
import { Home } from '../../models/home/home.model';
import { ApiService } from '../../shared/services/api.service';
import { AlertService } from '../../shared/services/alert.service';
import { Switch } from '../../models/editors/switch.model';

export const SUCCESS_MESSAGE = 'Nastavení bylo úspěšně uloženo!';
export const ERROR_MESSAGE = 'Při ukládání bohužel nastala chyba. Zkuste to prosím později.';

@Component({
  selector: 'swb-show-articles-on-homepage',
  templateUrl: './show-articles-on-homepage.component.html',
  providers: [FormControlService]
})

export class ShowArticlesOnHomepageComponent implements OnInit {
  public home: Home;
  public form: FormGroup;
  public get fieldsConfig(): Array<any> {
    return [
      new Switch({
        key: 'show_articles',
        label: 'Zobrazit na homepage'
      })
    ];
  }
  public FormEditors: any;
  public isInitialized = false;
  public isSaving = false;

  constructor(
    private _formService: FormControlService,
    private _apiService: ApiService,
    private _alertService: AlertService
  ) { }

  ngOnInit() {
    this._getHome('home');
  }

  public save() {
    this.isSaving = true;

    this._apiService.put(this.form.value, 'home/change').subscribe(
      (response: any) => {
        if ({ ...response }.status <= 0) {
          this._alertService.error(ERROR_MESSAGE);
        } else {
          this._alertService.success(SUCCESS_MESSAGE);
        }
        this.isSaving = false;
      },
      (error) => {
        this._alertService.error(ERROR_MESSAGE);
        this.isSaving = false;
      }
    );

  }

  private _getHome(uri: string) {
    this._apiService.get(uri)
      .subscribe(
        (response: any) => {
          this.home = { ...response }.data;
          this._setupForm();
          this.isInitialized = true;
        },
        (error) => console.error(error)
      );
  }

  private _setupForm(): void {
    this.form = this._formService.toFormGroup(this.fieldsConfig.slice(), this.home);
    this.form.valueChanges.subscribe(() => {
      this.save();
    });
    this.FormEditors = this._formService.toTemplateInput(this.fieldsConfig.slice(), this.home);
  }
}
